// extracted by css-extract-rspack-plugin
export default {"container":"container-Yxufpy","leftSection":"leftSection-eHt8yO","rightSection":"rightSection-wgFNUm"};